/**
 * App 全局配置常量（升级地址、版本门槛等）
 */

/** 最新版本 APK 下载地址（升级弹窗 / 系统浏览器跳转使用） */
export const APP_APK_DOWNLOAD_URL =
    'https://app-1309911649.cos.ap-beijing.myqcloud.com/qdy_106_jiagu_dp_qdy_gray.apk'

/** 广告桥接 / 看视频领金币功能所需的最低 App 版本号 */
export const AD_MIN_APP_VERSION = 104

/** 首页红包群 Banner / openRedGroup 所需的最低 App 版本号（低于此版本弹升级窗） */
export const RED_GROUP_MIN_APP_VERSION = 106
